import React from 'react';

/**
 * Injects the GoHighLevel (LeadConnector) chat widget script into the page.
 * Rendered directly in JSX so it mounts immediately with the React tree.
 */
export function GHLWidget() {
  return <script src="https://widgets.leadconnectorhq.com/loader.js" data-resources-url="https://widgets.leadconnectorhq.com/chat-widget/loader.js" data-widget-id="6a776d6c22509c8ee23afa60" data-source="WEB_USER" async data-id="element-107" data-mp="21dr87jjbocpm" />;
}